import React from "react";
import AppLayout from "@/components/layout/AppLayout";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Clock, Home } from "lucide-react";
import { Link } from "react-router-dom";
import { SUPPORT_EMAIL } from "@/constants/contact";

const PendingPage = () => {
  return (
    <AppLayout>
      <div className="container mx-auto px-4 py-6 max-w-lg">
        <Card>
          <CardHeader className="text-center">
            <div className="flex justify-center mb-4">
              <div className="rounded-full bg-amber-100 p-3">
                <Clock className="h-8 w-8 text-amber-600" />
              </div>
            </div>
            <CardTitle className="text-xl font-bold text-jungle">
              Application Pending Review
            </CardTitle>
          </CardHeader>

          <CardContent className="space-y-4">
            <div className="bg-amber-50 p-4 rounded-lg border border-amber-200">
              <p className="text-amber-800 font-medium mb-2">
                Your application is pending review
              </p>
              <p className="text-amber-700 text-sm">
                You are already active with another employer. Our staff needs to
                review your applications before you can continue. You should
                expect to be contacted by staff who will determine whether you
                can continue with your application.
              </p>
            </div>

            <div className="space-y-3">
              <h3 className="font-medium text-gray-900">What happens next?</h3>
              <ul className="space-y-2 text-sm text-gray-600">
                <li className="flex items-start">
                  <span className="inline-block w-2 h-2 bg-amber-500 rounded-full mt-1.5 mr-3 flex-shrink-0"></span>
                  Our staff will review your application status
                </li>
                <li className="flex items-start">
                  <span className="inline-block w-2 h-2 bg-amber-500 rounded-full mt-1.5 mr-3 flex-shrink-0"></span>
                  You'll be contacted by our team regarding your application
                </li>
                <li className="flex items-start">
                  <span className="inline-block w-2 h-2 bg-amber-500 rounded-full mt-1.5 mr-3 flex-shrink-0"></span>
                  Staff will determine if you can continue with your application
                </li>
              </ul>
            </div>

            <div className="bg-gray-50 p-4 rounded-lg">
              <p className="text-sm text-gray-600">
                If you have questions about your application status, please
                contact us at{" "}
                <a
                  href={`mailto:${SUPPORT_EMAIL}`}
                  className="text-honeycomb hover:underline"
                >
                  {SUPPORT_EMAIL}
                </a>
              </p>
            </div>
          </CardContent>

          <div className="p-6 pt-0 space-y-3">
            <Link to="/application-status" className="w-full block">
              <Button variant="outline" className="w-full">
                Check Application Status
              </Button>
            </Link>
            <Link to="/" className="w-full block">
              <Button className="w-full bg-honeycomb hover:bg-amber-500">
                <Home className="mr-2 h-4 w-4" /> Return to Home
              </Button>
            </Link>
          </div>
        </Card>
      </div>
    </AppLayout>
  );
};

export default PendingPage;

